module.exports = __webpack_public_path__ + "img/collaborate_47.fe75cecd.jpg";